import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "mall-nav",
  "aria-label": "함우리몰 빠른 메뉴"
}
const _hoisted_2 = ["href", "aria-current", "onClick"]
const _hoisted_3 = { class: "mall-nav__icon" }
const _hoisted_4 = {
  key: 0,
  class: "mall-nav__badge"
}
const _hoisted_5 = { class: "mall-nav__label" }

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import { useCart } from '@/composables/useCart'
import { useWishlist } from '@/composables/useWishlist'
import {
  MALL_CART_PATH,
  MALL_HOME_PATH,
  MALL_MYPAGE_PATH,
  MALL_WISHLIST_PATH,
} from '@/constants/mall'

interface NavItem {
  label: string
  icon: string
  to: string
  badge?: number
  exact?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MallBottomNav',
  setup(__props) {

const route = useRoute()
const { productCount } = useCart()
const { wishCount } = useWishlist()

const items = computed<NavItem[]>(() => [
  { label: '홈', icon: 'mdi-home-variant-outline', to: MALL_HOME_PATH, exact: true },
  { label: '찜하기', icon: 'mdi-heart-outline', to: MALL_WISHLIST_PATH, badge: wishCount.value },
  { label: '장바구니', icon: 'mdi-cart-outline', to: MALL_CART_PATH, badge: productCount.value },
  { label: '마이페이지', icon: 'mdi-account-outline', to: MALL_MYPAGE_PATH },
])

function isActive(item: NavItem): boolean {
  if (item.to === MALL_WISHLIST_PATH) return route.path.startsWith(MALL_WISHLIST_PATH)
  if (item.to === MALL_MYPAGE_PATH) {
    return route.path.startsWith(MALL_MYPAGE_PATH) && !route.path.startsWith(MALL_WISHLIST_PATH)
  }
  if (item.exact) return route.path === item.to
  return route.path === item.to || route.path.startsWith(`${item.to}/`)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: item.label,
        to: item.to,
        custom: ""
      }, {
        default: _withCtx(({ href, navigate }) => [
          _createElementVNode("a", {
            href: href,
            class: _normalizeClass(["mall-nav__item", { 'is-active': isActive(item) }]),
            "aria-current": isActive(item) ? 'page' : undefined,
            onClick: navigate
          }, [
            _createElementVNode("span", _hoisted_3, [
              _createVNode(AppIcon, {
                icon: item.icon,
                size: 22
              }, null, 8, ["icon"]),
              (item.badge)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(item.badge > 99 ? '99+' : item.badge), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
          ], 10, _hoisted_2)
        ]),
        _: 2
      }, 1032, ["to"]))
    }), 128))
  ]))
}
}

})